import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SCRIPT_ID = 'paradox-olivia-script';
const SCRIPT_SRC = 'https://dokumfe7mps0i.cloudfront.net/static/site/js/widget-client.js';
const CAREERS_PATH_PREFIX = '/careers';

export default function Paradox({
  baseUrl = process.env.REACT_APP_PARADOX_BASE_URL,
  apiKey = process.env.REACT_APP_PARADOX_API_KEY,
}) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!pathname.startsWith(CAREERS_PATH_PREFIX)) return;
    if (document.getElementById(SCRIPT_ID)) return;

    const addResourceHint = (rel, origin) => {
      const link = document.createElement('link');
      link.rel = rel;
      link.href = origin;
      if (rel === 'preconnect') link.crossOrigin = 'anonymous';
      document.head.appendChild(link);
    };

    // Loader script origin.
    addResourceHint('preconnect', 'https://dokumfe7mps0i.cloudfront.net');
    addResourceHint('dns-prefetch', 'https://dokumfe7mps0i.cloudfront.net');

    // The widget immediately calls back to its API origin (config/init
    // checks) and then loads its own JS bundle + fonts from a "cdn."
    // subdomain of that same host. Warming both up in parallel with the
    // loader script avoids paying DNS/TCP/TLS setup cost the moment those
    // requests actually fire.
    addResourceHint('preconnect', baseUrl);
    addResourceHint('dns-prefetch', baseUrl);

    try {
      const widgetCdnOrigin = `https://cdn.${new URL(baseUrl).hostname}`;
      addResourceHint('preconnect', widgetCdnOrigin);
      addResourceHint('dns-prefetch', widgetCdnOrigin);
    } catch (e) {
      // Ignore malformed base URL; loader script will still work.
    }

    window.oliviaChatBaseUrl = baseUrl;
    window.oliviaChatData = window.oliviaChatData || [];
    window.oliviaChatData.push(['setKey', apiKey]);
    window.oliviaChatData.push(['start']);

    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.fetchPriority = 'high';
    script.src = SCRIPT_SRC;
    document.body.appendChild(script);
  }, [pathname, baseUrl, apiKey]);

  return null;
}
